module.exports = __webpack_public_path__ + "files/7bbd231443ca338d17800b1c268d1093.png";